import React, { useState } from 'react'
import {
  Chip,
  IconButton,
  Tooltip,
  Dialog,
  DialogTitle,
  DialogContent,
  Button,
  Typography,
} from '@mui/material'
import AccessTimeIcon from '@mui/icons-material/AccessTime'
import { router } from '@inertiajs/react'
import TimeLapseCalendar from './TimeLapseCalendar'

export default function TimeLapseControl({
  tenantSlug, propertyId, simulatedDate,
}) {
  const [dialogOpen, setDialogOpen] = useState(false)
  const [done, setDone] = useState(false)

  const handleComplete = () => {
    setDone(true)
  }

  const handleClose = () => {
    setDialogOpen(false)
    setDone(false)
    // Reload Inertia page data so navbar badge shows updated simulated_date
    router.reload()
  }

  // If time lapse is already active, show badge
  if (simulatedDate) {
    return (
      <>
        <Chip
          icon={<AccessTimeIcon />}
          label={`Zeitraffer: ${simulatedDate}`}
          color="warning"
          size="small"
          onClick={() => setDialogOpen(true)}
          data-testid="time-lapse-badge"
        />
        <Dialog
          open={dialogOpen}
          maxWidth="lg"
          fullWidth
          disableEscapeKeyDown={!done}
          onClose={(event, reason) => {
            if (!done && (reason === 'backdropClick' || reason === 'escapeKeyDown')) return
            handleClose()
          }}
          data-testid="time-lapse-dialog"
        >
          <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Typography variant="h6">Zeitraffer</Typography>
            {done && (
              <Button
                variant="outlined"
                size="small"
                onClick={handleClose}
                data-testid="time-lapse-dialog-close"
              >
                Schließen
              </Button>
            )}
          </DialogTitle>
          <DialogContent>
            <TimeLapseCalendar
              tenantSlug={tenantSlug}
              propertyId={propertyId}
              simulatedDate={simulatedDate}
              onComplete={handleComplete}
            />
          </DialogContent>
        </Dialog>
      </>
    )
  }

  // Not active — show clock icon to start
  return (
    <>
      <Tooltip title="Zeitraffer">
        <IconButton
          size="small"
          onClick={() => {
            // Initialize time lapse with today's date, then open dialog
            const today = new Date().toISOString().split('T')[0]
            router.patch(`/m/${tenantSlug}/properties/${propertyId}/time_lapse`, {
              simulated_date: today,
            }, {
              onSuccess: () => setDialogOpen(true),
            })
          }}
          data-testid="time-lapse-button"
        >
          <AccessTimeIcon fontSize="small" />
        </IconButton>
      </Tooltip>
      <Dialog
        open={dialogOpen}
        maxWidth="lg"
        fullWidth
        disableEscapeKeyDown={!done}
        onClose={(event, reason) => {
          if (!done && (reason === 'backdropClick' || reason === 'escapeKeyDown')) return
          handleClose()
        }}
        data-testid="time-lapse-dialog"
      >
        <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography variant="h6">Zeitraffer</Typography>
          {done && (
            <Button
              variant="outlined"
              size="small"
              onClick={handleClose}
              data-testid="time-lapse-dialog-close"
            >
              Schließen
            </Button>
          )}
        </DialogTitle>
        <DialogContent>
          <TimeLapseCalendar
            tenantSlug={tenantSlug}
            propertyId={propertyId}
            simulatedDate={simulatedDate}
            onComplete={handleComplete}
          />
        </DialogContent>
      </Dialog>
    </>
  )
}
